import { DEFAULT_TOOLTIP_POSITION } from './constants'
import { TooltipCoordinates, TooltipPosition } from './types'

/**
 * Calculates the hint point based on the tooltip position and target position.
 */
const positions: Record<TooltipPosition, [number, number]> = {
  top: [0.5, 0],
  right: [1, 0.5],
  bottom: [0.5, 1],
  left: [0, 0.5],
  right_bottom: [1, 1],
  left_bottom: [0, 1],
}

export function getTipPoint(
  position: TooltipPosition,
  tooltipTargetPosition: DOMRect,
): TooltipCoordinates {
  const [x, y] = positions[position] || positions[DEFAULT_TOOLTIP_POSITION]

  return {
    x: tooltipTargetPosition.left + tooltipTargetPosition.width * x,
    y: tooltipTargetPosition.top + tooltipTargetPosition.height * y,
  }
}
